
//SlickSliders
/*
jQuery(function() {
  jQuery('#slider').slick({
  dots: false,
  infinite: true,
  slidesToShow: 1,
  adaptiveHeight: true,
  asNavFor: '#carousel, #captions',
  });
  jQuery('#captions').slick({
  dots: false,
  arrows: false,
  infinite: true,
  slidesToShow: 1,
  asNavFor: '#slider, #carousel',
  responsive: [
    {
      breakpoint: 992,
      settings: {
        arrows: true,
      }
    }
  ]
  });
  jQuery('#carousel').slick({
  dots: false,
  infinite: true,
  focusOnSelect: true,
  arrows: true,
  slidesToShow: 5,
  slidesToScroll: 1,
  vertical: true, 
  verticalSwiping:true,
  asNavFor: '#slider, #captions',
  responsive: [
    {
      breakpoint: 1550,
      settings: {
        slidesToShow: 5,
        vertical: true, 
        verticalSwiping:true,
      }
    },
    {
      breakpoint: 1400,
      settings: {
        slidesToShow: 4,
        vertical: true, 
        verticalSwiping:true,
      }
    },
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 5,
        arrows: false,
        vertical: false, 
        verticalSwiping:false,
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 3,
        arrows: false,
        vertical: false, 
        verticalSwiping:false,
      }
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 3,
        arrows: false,
        vertical: false, 
        verticalSwiping:false,
      }
    },
    {
      breakpoint: 420,
      settings: {
        slidesToShow: 3,
        arrows: false,
        vertical: false, 
        verticalSwiping:false,
      }
    }
  ]
  });
  jQuery('.thumb-scroller').slick({
    dots: true,
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 5,
    responsive: [
      {
        breakpoint: 2400,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 5,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 1980,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }
    ]
  });
});
*/

// gf-bootstrap-orbital.js
(function () {
  /**
   * Utility: add one or more classes without duplicates.
   */
  function addClass(el, cls) {
    if (!el) return;
    cls.split(/\s+/).forEach(c => c && el.classList.add(c));
  }

  function hasClass(el, c) {
    return el && el.classList.contains(c);
  }

  /**
   * Map a single form to Bootstrap.
   */
  function enhanceForm(form) {
    if (!form) return;

    // 1) Field wrappers spacing
    form.querySelectorAll('.gfield').forEach(f => addClass(f, 'mb-3'));

    // 2) Labels -> .form-label
    form.querySelectorAll('.gfield_label').forEach(label => addClass(label, 'form-label'));

    // 3) Inputs -> .form-control (text-like)
    form.querySelectorAll(
      '.ginput_container input[type="text"],' +
      '.ginput_container input[type="email"],' +
      '.ginput_container input[type="tel"],' +
      '.ginput_container input[type="number"],' +
      '.ginput_container input[type="url"],' +
      '.ginput_container input[type="password"],' +
      '.ginput_container input[type="date"],' +
      '.ginput_container input[type="time"]'
    ).forEach(input => addClass(input, 'form-control'));

    // 4) Textarea -> .form-control
    form.querySelectorAll('.ginput_container textarea').forEach(t => addClass(t, 'form-control'));

    // 5) Select -> .form-select
    form.querySelectorAll('.ginput_container select').forEach(sel => addClass(sel, 'form-select'));

    // 6) Checkboxes/Radios (Orbital): .gchoice wrappers
    form.querySelectorAll('.gfield_checkbox .gchoice, .gfield_radio .gchoice').forEach(choice => {
      addClass(choice, 'form-check');

      // input in choice
      var input = choice.querySelector('input[type="checkbox"], input[type="radio"]');
      if (input && !hasClass(input, 'form-check-input')) addClass(input, 'form-check-input');

      // label in choice
      var label = choice.querySelector('label');
      if (label && !hasClass(label, 'form-check-label')) addClass(label, 'form-check-label');
    });

    // 7) Validation: add .is-invalid if wrapper has error class (optional)
    form.querySelectorAll('.gfield.gfield_error').forEach(f => {
      // inputs / selects / textareas inside invalid field
      f.querySelectorAll('input, select, textarea').forEach(ctrl => {
        // keep form-check-input + add is-invalid, or just is-invalid for others
        addClass(ctrl, 'is-invalid');
      });
    });
  }

  /**
   * Enhance all forms currently on the page.
   * If you want to scope to a specific form ID, change the selector to '#gform_2'.
   */
  function enhanceAll() {
    document.querySelectorAll('form[id^="gform_"]').forEach(enhanceForm);
  }

  // Initial run
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceAll);
  } else {
    enhanceAll();
  }

  // Listen for GF re-render (gform_post_render) if jQuery present
  if (window.jQuery && typeof window.jQuery === 'function') {
    window.jQuery(document).on('gform_post_render', function (e, formId) {
      var form = document.getElementById('gform_' + formId);
      enhanceForm(form);
    });
  }

  // Fallback: MutationObserver for any dynamic injections inside .gform_wrapper
  var wrapper = document.querySelector('.gform_wrapper, .gform-theme');
  if (wrapper && 'MutationObserver' in window) {
    var mo = new MutationObserver(function (mutations) {
      var needsEnhance = mutations.some(function (m) {
        return (m.addedNodes && m.addedNodes.length);
      });
      if (needsEnhance) enhanceAll();
    });
    mo.observe(wrapper, { childList: true, subtree: true });
  }
})();


document.addEventListener("DOMContentLoaded", function () {
    const submit = document.querySelector('input[type="submit"].search-submit');

    if (submit) {
        const wrapper = document.createElement("span");
        wrapper.className = "btn-like";

        // Insert wrapper around the input
        submit.parentNode.insertBefore(wrapper, submit);
        wrapper.appendChild(submit);
    }
});